export const getPharmaciesListForDropDown = (pharmaciesList, searchList) => {
  const list = [];
  if (pharmaciesList?.length) {
    pharmaciesList.forEach(item => {
      const { key, imageUrl, address, translators, areaKey } = item;

      const searchedIndex = searchList?.findIndex(itemObj => itemObj.key === key);

      list.push({
        isSelected: searchedIndex !== -1,
        fieldValue: translators[1]?.name,
        itemImage: imageUrl,
        value: key,
        description: address,
        extras: {
          key,
          imageUrl,
          pharmacyName: translators[1]?.name,
          address,
          areaKey,
        },
      });
    });
  }
  return list;
};
